import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useEffectOnce } from 'react-use';
import PaymentSuccessful from '../../resource/figma-images/payment-successful.svg';
import PaymentFailed from '../../resource/figma-images/payment-failed.svg';

import {
  HeroLogo,
  PageTitle,
  StepIndicator,
  CheckIcon,
  ResultContainer,
  ResultContainerContent,
  Instruction, Button,
} from '../../components';
import { useLoading } from '../../context';
import ContinueToPayImage from "../../resource/figma-images/continue-to-pay-image.svg";
import {getPageHeroLogo, getThemeColor} from "../../customHostConfigOnClient";

const getCheckPaymentStatusUrl = (paymentMethod, paymentId) => {
  switch (paymentMethod) {
    case 'credit':
      return `/api/alipay-credit-card/payment/${paymentId}`;
    case 'dana':
      return `/api/alipay-dana/payment/${paymentId}`;
    case 'alipayplus':
    default:
      return `/api/alipay/payment/${paymentId}`;
  }
}

export const AlipayPaymentResult = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const paymentId = query.get('paymentId');
  const paymentMethod = query.get('method');
  const env = query.get('env');
  const { showLoading, hideLoading } = useLoading();

  const [paymentStatus, setPaymentStatus] = useState('PAYING');
  const [errorMessage, setErrorMessage] = useState('');

  const fetchPaymentStatus = useCallback(async () => {
    try {
      const checkStatusUrl = getCheckPaymentStatusUrl(paymentMethod, paymentId);
      const response = await axios.get(`${checkStatusUrl}?env=${env}`);
      const { transactionStatus, errors } = response.data;

      if (transactionStatus === 'SUCCESS') {
        setPaymentStatus('PAY_SUCCESS');
      } else if (transactionStatus === 'ERROR' && errors[0].code === '2005') {
        setPaymentStatus('ERROR');
        // setErrorMessage('付款超时。请返回重新提交表单以生成一个新的二维码。');
        setErrorMessage('Payment timeout.');
      } else if (transactionStatus === 'ERROR') {
        setPaymentStatus('ERROR');
        // setErrorMessage('付款失败，请检查您的付款信息并重试。');
        setErrorMessage('Payment failed. Please check your payment information and try again.');
      } else if (transactionStatus === 'REDIRECT') {
        // Redirect to 3d secure page.
        const threeDRedirectURL = response.data.extraData && response.data.extraData.redirectUrl;
        if (threeDRedirectURL) window.location.href = threeDRedirectURL;
        return;
      } else {
        setPaymentStatus('PAYING');
        return;
      }

      hideLoading();
    } catch (error) {
      console.error('Error fetching payment status:', error);
    }
  }, [hideLoading, paymentId]);

  useEffectOnce(() => {
    showLoading();
    fetchPaymentStatus();
  });

  return (
    <ResultContainer>
      <HeroLogo logo={getPageHeroLogo()} />

      {
        paymentStatus === 'PAY_SUCCESS' ? (
            <ResultContainerContent>
              {/*<PageTitle>支付结果</PageTitle>*/}
              <PageTitle>Payment Successful</PageTitle>
              {/*<StepIndicator step={3} />*/}
              {/*<PageTitle>成功</PageTitle>*/}
              <img src={PaymentSuccessful}/>
              {/*<PageTitle>Payment Successful</PageTitle>*/}
              {/*<CheckIcon color="#1AB260" size="100px"/>*/}
              {/*<Instruction>您的付款已经完成。</Instruction>*/}
              <Instruction>Thank you for paying your fees.</Instruction>
              <Button width='70%' $themeColor={getThemeColor()} onClick={() => window.location='/'+window.location.search} block>
                Back to payment Page
              </Button>
            </ResultContainerContent>
          ) :
          paymentStatus === 'ERROR' ? (
            <ResultContainerContent>
              <PageTitle>Payment Failed</PageTitle>
              {/*<StepIndicator step={3} />*/}
              <img src={PaymentFailed}/>
              {/*<PageTitle>Payment Failed</PageTitle>*/}
              <Instruction>We are sorry, there was an error processing your payment.</Instruction>
              {errorMessage && <Instruction>{errorMessage}</Instruction>}
            </ResultContainerContent>
          ) : (
            <ResultContainerContent>
            {/*<PageTitle>支付结果</PageTitle>*/}
            <PageTitle>Payment Result</PageTitle>
            {/*<StepIndicator step={3} />*/}
            {/*<PageTitle>检查中...</PageTitle>*/}
            <PageTitle>Checking...</PageTitle>
            {errorMessage && <Instruction>{errorMessage}</Instruction>}
          </ResultContainerContent>
        )
      }
    </ResultContainer>
  );
};
